module.exports = __webpack_public_path__ + "static/img/header-U17.167a031.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header-U17.jpg
// module id = BOdy
// module chunks = 0